import { useEffect, Suspense } from "react";
import { createBrowserRouter, useLocation } from "react-router-dom";
import { homeRoutes } from "@/features/home/homeRoute";
import {
  propertyRoutes,
  propertyRoutesPrivate
} from "@/features/property/propertyRoute";
import { dashboardRoutes } from "@/features/dashboard/dashboardRoute";
import { userRoutes, userRoutesPrivate } from "@/features/user/userRoute";
import RouterGuard from "@/common/layouts/RouterGuard";
import { termsRoutes } from "@/features/terms/termRoute";
import { disclaimerRoute } from "@/features/disclaimer/disclaimerRoute";
import { privacyPolicyRoute } from "@/features/privacyPolicy/privacyPolicyRoute";
import { aboutUsRoute } from "@/features/aboutUs/aboutUsRoute";
import { contactUsRoute } from "@/features/contactUs/contactUsRoute";
import { helpAndSupportRoute } from "@/features/helpAndSupport/helpAndSupportRoute";
import { aiAgentChatBotRoutes } from "@/features/aiAgentChatBot/aiAgentChatBotRoute";
import { marketInsightsRoutes } from "@/features/marketInsights/marketInsightsRoute";

import Layout from "@/common/layouts/Layout";
import LayoutWrapper from "@/common/layouts/DashboardLayout";
import NotFoundPage from "@/common/organisms/NotFoundPage";

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null;
};

const routes = [
  {
    path: "/",
    element: (
      <Suspense>
        <ScrollToTop />
        <Layout />
      </Suspense>
    ),
    children: [
      { ...homeRoutes },
      { ...propertyRoutes },
      { ...userRoutes },
      { ...termsRoutes },
      { ...disclaimerRoute },
      { ...privacyPolicyRoute },
      { ...aboutUsRoute },
      { ...contactUsRoute },
      { ...helpAndSupportRoute },
      { ...aiAgentChatBotRoutes },
      { ...marketInsightsRoutes }
    ]
  },
  {
    path: "/manage",
    element: (
      <RouterGuard>
        <Suspense>
          <LayoutWrapper>
            <ScrollToTop />
          </LayoutWrapper>
        </Suspense>
      </RouterGuard>
    ),
    children: [
      { ...dashboardRoutes },
      { ...userRoutesPrivate },
      { ...propertyRoutesPrivate }
    ]
  },
  {
    path: "*",
    element: <NotFoundPage />
  }
];

const future = {
  future: {
    v7_relativeSplatPath: true, // Enables relative paths in nested routes
    v7_fetcherPersist: true, // Retains fetcher state during navigation
    v7_normalizeFormMethod: true, // Normalizes form methods (e.g., POST or GET)
    v7_partialHydration: true, // Supports partial hydration for server-side rendering
    v7_skipActionErrorRevalidation: true // Prevents revalidation when action errors occur
  }
};

const router = createBrowserRouter(routes, future);

export { routes };
export default router;
